import * as React from 'react';

import {Tokenized} from 'shells/entity/entity-display-values/relationship/tokenized';

import styles from '../cell.module.css';

/**
 * We get different attributes depending on the object type, usually `name` for
 * entities (things with an API ID) and a string `value` for everything else.
 */
type TokenizedRowItem = {
    value: {
        entityId?: string;
        value: string;
    };
};

type Props = {
    value: TokenizedRowItem[];
};

export function CellStringsTokenized(props: Props) {
    const transformedValueArray = props.value.map((valueObject) => {
        return {
            entityId: valueObject.value.entityId,
            value: valueObject.value.value,
        };
    });

    return (
        <div className={styles['cell-content']}>
            <Tokenized value={transformedValueArray} />
        </div>
    );
}
